import React from 'react';

import {
    AbilityLookup,
    Action,
    DataOriginRefData,
    Feat,
    Race,
    RaceUtils,
    RacialTrait,
    RacialTraitUtils,
    RuleData,
    SnippetData,
    Spell,
    CharacterTheme,
} from '@dndbeyond/character-rules-engine/es';

import { RacialTraitFeatureSnippet } from '../FeatureSnippet';

interface Props {
    onActionUseSet: (action: Action, uses: number) => void;
    onActionClick: (action: Action) => void;
    onSpellClick: (spell: Spell) => void;
    onSpellUseSet: (spell: Spell, uses: number) => void;
    onFeatureClick: (feature: RacialTrait) => void;
    feats: Array<Feat>;
    snippetData: SnippetData;
    ruleData: RuleData;
    abilityLookup: AbilityLookup;
    dataOriginRefData: DataOriginRefData;
    isReadonly: boolean;
    proficiencyBonus: number;
    theme: CharacterTheme;
    racialTraits: Array<RacialTrait>;
}
export default class RaceDetail extends React.PureComponent<Props> {
    render() {
        const { racialTraits, ...restProps } = this.props;

        if (racialTraits.length === 0) {
            return null;
        }

        return (
            <div className="ct-race-detail">
                {racialTraits.map((racialTrait) => (
                    <RacialTraitFeatureSnippet
                        {...restProps}
                        key={RacialTraitUtils.getId(racialTrait)}
                        racialTrait={racialTrait}
                    />
                ))}
            </div>
        );
    }
}
